import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import sendRequest from "../utils/sendRequest";
import validators from "../utils/validators";
import SecureLS from "secure-ls";
import { checkAuth } from "../utils/checkAuth";
import Navbar from "../components/Navbar";
import Loader from "../components/Loader";
import swal from "sweetalert";
import { encrypt } from "../utils/cipher";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../App.css";
import { InputAdornment } from "@mui/material";
import CryptoJS from "crypto-js";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: 5,
    boxShadow: "0px 3px 15px #BCB0B0",
    background: " #EEEEEE",
    maxWidth: "none !important"
  },
  email: {
    display: "flex",
    flexDirection: "column",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#272782",
  },
  password: {
    display: "flex",
    flexDirection: "column",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#272782",
  },
  email_line: {
    width: "100%",
    height: "2px",
    backgroundColor: "#272782",
    marginTop: "10px",
  },

  container: {
    width: "100% !important",
    height: "80% !important",
    display: "flex !important",
    justifyContent: "center",
    alignItems: "center"
  },

  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: 5,
    boxShadow: "0px 3px 15px #BCB0B0",
    background: " #EEEEEE",
  },
  [theme.breakpoints.down("xs")]: {
    card: {
      maxHeight: " 80%",
      width: "100%",
      maxWidth: "90%",
      //backgroundColor:"red",
    },
    email_line: {
      width: "100%",
      height: "2px",
      backgroundColor: "#272782",
      marginTop: "10px",
    },
  },
}));

const theme = createTheme();

const Login = () => {
  let navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });
  const [loader, setLoader] = useState(false);
  var ls = new SecureLS();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(formValues);
    const result = validate(formValues);

    if (result.isValid) {
      setLoader(true);
      const payload = {
        email: formValues.email.toLowerCase(),
        password: formValues.password
      }
      let encryptedformValues = encrypt(payload)
      sendRequest("/api/auth/login", { payload: encryptedformValues })
        .then((result) => {
          // console.log(result);
          if (result.type === "success") {
            const { hash, token, email,pmsdata,pmsdata_length, ...responseData } = result;
            const computedHash = CryptoJS.SHA256(JSON.stringify(responseData)).toString()

            if (computedHash === hash) {
              ls.set("data", { token: result.token });
              ls.set("firstName", { firstName: result.firstName });
              ls.set("email", result.email);
              ls.set("pmsdata", result.pmsdata);
              ls.set("pmsdata_length", result.pmsdata_length);
              ls.set("userType", result.email == "admin@apmiindia.org" ? "PMS" : "SEBI")
              // console.log("email of admin", ls.get("email"))
              setLoader(false);
              navigate("/Landing");
              // navigate("/AUMUploadUtility");
            }
            else {
              swal("Error Occured!!", "Response has been tampered with!", "error");
            }
          } else {
            setLoader(false);
            swal("",  "Something went wrong", "error");
          }
        })
        .catch((error) => {
          setLoader(false);
          if (error.includes("You are already logged in elsewhere.")) {
            swal(error, {
              buttons: ["No", "Yes"],
            }).then(async (willLogout) => {
              if (willLogout) {
                await axios.post(
                  "/api/auth/force-logout",
                    {
                      email: formValues.email.toLowerCase(),
                      password: formValues.password,
                    },
                   { 
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );
              } else {
                console.log("User Deny!!");
              }
            });
          } else {
            swal("", error, "error");
          }
        });
    } else {
      setLoader(false);
      // console.log(result.message);
      swal("", result.message, "error");
    }
  };

  // console.log(">>>>>>>>>>>>>>>", ls.get("firstName"))
  const validate = () => {
    const emailValidate = validators.validateEmail(formValues.email);
    const passwordValidate = validators.validatePassword(formValues.password);
    console.log("eerrr",emailValidate);
    console.log("passwordValidate",passwordValidate);

    if (emailValidate.isValid != true) {
      return {
        isValid: emailValidate.isValid,
        message: emailValidate.message,
      };
    }
    else if (passwordValidate.isValid != true) {
      return {
        isValid: passwordValidate.isValid,
        message: passwordValidate.message,
      };
    }
    else{
      return {
        isValid: true,
        message: "Valid Email & Password"
      }
    }
  };

  const cardStyles = useStyles(theme);

  return (
    <ThemeProvider theme={theme}>
      <Navbar />
      <Loader visible={loader} />
      <Container
        className={cardStyles.container}
        component="main"
        maxWidth="xs"
        style={
          {
            height: "80%",
            display: "flex",
            alignItems: "center"
          }
        }
      >
        <Card className={` ${cardStyles.card}`} >
          <Box
            sx={{

              margin: "20px",
              // marginLeft: "10px",
              width: "80%",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#272782",
                    fontWeight: "400",
                    height: "45px",
                    left: "702px",
                    top: "340px",
                    fontFamily: "Roboto-Medium",
                    fontStyle: "normal",
                    fontSize: "36px",
                    lineHeight: "42px",
                  }}
                >

                  LOGIN
                </Typography>
              </Box>
              <Box className={cardStyles.email_line} />
            </Box>

            <Box component="form" onSubmit={handleSubmit}>
              <Box className={cardStyles.email}>
                <p style={{ fontWeight: "600", fontSize: "16px" }}>EMAIL</p>
                <TextField
                  variant="standard"
                  name="email"
                  type="email"
                  placeholder="Enter email id"
                  value={formValues.email}
                  onChange={handleChange}
                  required
                  inputProps={{
                    maxLength: 255,
                  }}
                  sx={{
                    width: "100%",
                  }}
                />
                <div id="error-email"></div>
              </Box>

              <Box className={cardStyles.password}>
                <p style={{ fontWeight: "600", fontSize: "16px" }}>PASSWORD</p>
                <TextField
                  variant="standard"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={formValues.password}
                  onChange={handleChange}
                  required
                  inputProps={{
                    maxLength: 64,
                  }}
                  sx={{
                    width: "100%",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!showPassword ? (
                          <VisibilityOffIcon
                            style={{ cursor: "pointer", color: "#58585e" }}
                            onClick={() => {
                              setShowPassword(true);
                            }}
                          />
                        ) : (
                          <VisibilityIcon
                            style={{ cursor: "pointer", color: "#58585e" }}
                            onClick={() => {
                              setShowPassword(false);
                            }}
                          />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                <div id="error-password"></div>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  className={cardStyles.Button}
                  type="submit"
                  variant="contained"
                  //onClick={handleSubmit}
                  sx={{
                    bgcolor: "#272782",
                    mt: 5,
                    width: "150px",
                    borderRadius: 0,
                    height: 35,
                    fontWeight: 300,
                    fontSize: "16px",
                    lineHeight: "23px",
                    display: "flex",
                    align: "center",
                    color: "#FFFFFF",
                  }}
                >
                  <span style={{ padding: 10 }}>Login{"     "}</span>
                </Button>

              </Box>
            </Box>
          </Box>
        </Card>
      </Container>
    </ThemeProvider>
  );
};

export default Login;
